routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.productsListFiltersCategory', {
      url: "moto-partes",
      template: `<products-list-filters sh-ctrl="shCtrl"></products-list-filters>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/products-list-filters/products-list-filters.config.js